import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-my-task-confirmation-dialog',
  templateUrl: './my-task-confirmation-dialog.component.html',
  styleUrls: ['./my-task-confirmation-dialog.component.scss']
})
export class MyTaskConfirmationDialogComponent implements OnInit {

  constructor(
    readonly dialogRef: MatDialogRef<MyTaskConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }) { }

  ngOnInit(): void { }

  cancel(): void {
    this.dialogRef.close();
  }

  submit(): void {
    this.dialogRef.close(true);
  }
}
